import {appVersion} from './version';

export const environment = {
  production: false,
  websocketUrl: 'wss://stage.frankli.io/livesync',
  apiUrl: 'https://stage.frankli.io/api',
  sso: {
    redirectUri: 'https://stage.frankli.io/callback',
    logoutUri: 'https://stage.frankli.io',
    microsoft: {
      clientId: '56711260-943e-4081-9e4e-5babef909539',
    },
    google: {
      clientId: '995821072743-26ecgtabva2uib6kb6ih8ig1v0gr78he.apps.googleusercontent.com',
    },
    hrLocker: {
      loginUrl: 'https://login.hrlocker.com/SignIn'
    }
  },
  sentry: {
    enabled: true,
    environment: 'stage',
    key: 'https://c07fba51f1fb4eb1903d83f2551e07d2@sentry.io/1231287',
  },
  intercom: {
    id: 'yrb9n1sk',
    enabled: false
  },
  vincere: {
    redirectUri: 'https://stage.frankli.io/callback-vincere'
  },
  zendesk: {
    redirectUri: 'https://stage.frankli.io/callback-zendesk',
    clientId: 'zdg-frankli-io'
  },
  password: {
    minimumLength: 8,
    maximumLength: 100
  },
  integrations: {
    slack: {
      enabled: true
    }
  },
  mock: {
    enabled: false,
    apiUrl: 'https://stage.frankli.io'
  },
  version: appVersion,
  baseUrl: 'https://stage.frankli.io',
};
